var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-img"},[_c('img',{key:_vm.src,style:(_vm.imgStyles),attrs:{"src":_vm.src,"alt":_vm.alt}}),(!_vm.isLoaded)?_c('div',{staticClass:"v-img__spinner"},[_c('div'),_c('div'),_c('div'),_c('div')]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }